import authentication from "@irati/auth";
import { getMedicalAccount } from "../services/medical";
import errorCodes from "../errorCodes";
var hint = "platform.apps.medical.partiallyComplete";
export default (function () {
    if (!authentication.apps("medical")) {
        return Promise.resolve({ hint: null });
    }
    return getMedicalAccount(authentication.user()).then(function (user) {
        return !user.activated ? { hint: hint } : { hint: null };
    }).catch(function (err) {
        var _a;
        if (((_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data.code) !== errorCodes.PBMEDResourceNotFound) {
            throw err;
        }
        else {
            return { hint: hint };
        }
    });
});
